import { useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import DocumentDetailPanel from "./DocumentDetailPanel";

// Transitional shell (removed in step 6): PDF iframe on the left, the shared
// DocumentDetailPanel on the right. The panel owns saving; call sites only get
// `onFieldSaved` to mirror edits into their own lists.
export default function DocumentDetailDialog({
  doc,
  open,
  onOpenChange,
  onFieldSaved,
  fallbackMemberNames = [],
  onOpen,
}) {
  const token = localStorage.getItem("token") || "";

  useEffect(() => {
    if (open && doc?.blob_name && onOpen) onOpen(doc.blob_name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, doc]);

  if (!doc) return null;
  const title = doc.display_name || doc.original_filename || doc.blob_name;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl h-[85vh] flex flex-col p-0 gap-0">
        <DialogHeader className="sr-only">
          <DialogTitle>Document details</DialogTitle>
        </DialogHeader>
        <div className="flex flex-1 overflow-hidden">
          <div className="flex-1 border-r bg-gray-50">
            {doc?.blob_name ? (
              <iframe
                src={`/api/documents/pdf/${encodeURIComponent(doc.blob_name)}?token=${encodeURIComponent(token)}`}
                className="w-full h-full border-0"
                title={title || "Document Preview"}
              />
            ) : (
              <div className="flex items-center justify-center h-full text-gray-400 text-sm">
                No preview available
              </div>
            )}
          </div>
          <div className="w-[380px] flex flex-col overflow-hidden">
            {open && doc?.blob_name && (
              <DocumentDetailPanel
                blobName={doc.blob_name}
                seedDoc={doc}
                onFieldSaved={onFieldSaved}
                fallbackMemberNames={fallbackMemberNames}
              />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
